<img *ngIf="_url" [src]="_url" />
<div class="tools">
  <div class="toolbar">
    <button *ngIf="showEditButton && FileUploadStatus.Queued === status && file" mat-icon-button (click)="editClick()">
      <mat-icon class="icon">crop</mat-icon>
    </button>
    <button *ngIf="showDeleteButton" mat-icon-button (click)="deleteClick()">
      <mat-icon class="icon">delete</mat-icon>
    </button>
  </div>
</div>
<glxy-uploader-file-status [status]="status" *ngIf="status !== null"></glxy-uploader-file-status>
